import { createContext, useContext, useState } from "react";
import CryptoUtils from "../util/cryptoUtils";

const Rolecontext = createContext();

export const RoleProvider = ({ children }) => {
    const [selectedRole, setSelectedRole] = useState(() => {
        const storedRole = CryptoUtils.getFromLocalStorage("roleId");
        return storedRole ? JSON.parse(storedRole) : [];
    });

    const updateRole = (roleId, roleName) => {
        const roleArray = [{ roleId, roleName }]; // Store as array
        setSelectedRole(roleArray);
        CryptoUtils.saveToLocalStorage("roleId", roleId?.toString());
    };

    return (
        <Rolecontext.Provider value={{ selectedRole, updateRole }}>
            {children}
        </Rolecontext.Provider>
    );
};

export const useRole = () => useContext(Rolecontext);
